import { Table as ATable, Progress, Tooltip, Typography } from 'antd';
import './AsyncTasksModal.css';
import CustomButton from '../../common/Button/Button';
import { CloudDownloadOutlined } from '@ant-design/icons';
import moment from 'moment';

export default function AsyncTaskTable({
  data,
  loading,
  handleSort,
  sortField,
}) {
  const { Text } = Typography;

  const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
  };

  const colors = {
    COMPLETED: '#389E0D',
    COMPLETED_WITH_ERRORS: '#389E0D',
    IN_PROGRESS: '#fd7e14',
    FAILED: '#D9363E',
  };

  const columns = [
    {
      key: 'taskId',
      title: 'Task ID',
      dataIndex: 'taskId',
      align: 'center',
      sorter: true,
      sortOrder: sortField?.field === 'taskId' ? sortField?.order : null,
    },
    {
      key: 'taskName',
      title: 'Process Name',
      dataIndex: 'taskName',
      align: 'center',
    },
    {
      key: 'createdAt',
      title: 'Date Requested',
      dataIndex: 'createdAt',
      render: (value) => {
        const date = value.split('T');
        const time = moment(date[1], 'HH:mm:ss.SSSSSS').format('hh:mm:ss A');
        return (
          <Tooltip title={value}>
            <Text
              style={{
                display: 'block',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {`${date[0]} | ${time}`}
            </Text>
          </Tooltip>
        );
      },
      sorter: true,
      sortOrder: sortField?.field === 'createdAt' ? sortField?.order : null,
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (result, record) => {
        const { total, failed, duplicate, status } = record;
        return (
          <Tooltip
            color={'white'}
            title={
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Text strong={total}>{result}</Text>
                </div>
                {status !== 'IN_PROGRESS' && total && (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '12px',
                      }}
                    >
                      <Text> Total: {total || 0}</Text>
                      <Text style={{ color: 'green' }}>
                        Success : {total - failed - duplicate || 0}
                      </Text>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '12px',
                      }}
                    >
                      <Text style={{ color: 'red' }}>
                        Failed : {failed || 0}
                      </Text>
                      <Text style={{ color: 'red' }}>
                        Duplicate : {duplicate || 0}
                      </Text>
                    </div>
                  </>
                )}
              </>
            }
          >
            <Text className="line-clamp" style={{ color: colors[result] }}>
              {result}
            </Text>
          </Tooltip>
        );
      },
    },
    {
      key: 'result',
      title: 'Result',
      dataIndex: 'result',
      align: 'center',
      width: 200,
      render: (result, record) => {
        const { status, error, progress } = record;

        return (status === 'COMPLETED' ||
          status === 'COMPLETED_WITH_ERRORS' ||
          status === 'FAILED') &&
          result &&
          result.startsWith('https') ? (
          <CustomButton
            shape="round"
            variant="link"
            size="small"
            href={result}
            icon={<CloudDownloadOutlined />}
          >
            {error ? 'Export Failed Records' : 'Download Result'}
          </CustomButton>
        ) : status === 'IN_PROGRESS' ? (
          <Progress
            percent={progress}
            percentPosition={{ align: 'center', type: 'inner' }}
            size={['85%', 15]}
            strokeColor={twoColors}
          />
        ) : (
          <Tooltip title={<>{result}</>}>
            <Typography.Text className="line-clamp">{result}</Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      key: 'userId',
      title: 'Requested By',
      dataIndex: 'userId',
      align: 'center',
      sorter: true,
      sortOrder: sortField?.field === 'userId' ? sortField?.order : null,
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    handleSort({ field, order });
  };

  return (
    <div style={{ margin: '24px 0' }}>
      <ATable
        loading={loading}
        onFilter
        style={{ height: '100%' }}
        columns={columns}
        dataSource={data}
        pagination={false}
        onChange={handleTableChange}
        scroll={{
          y: 'calc(100vh - 375px)',
        }}
      />
    </div>
  );
}
